/* src/app/modules/concept/salesreport/salesreport.component.css */
:host {
  --sr-brand: #e3fd64;
  --sr-brand-d: #4d7a00;
  --sr-text: #1a1d23;
  --sr-muted: #6b7280;
  --sr-border: #e5e7eb;
  --sr-bg: #f4f6f8;
  --sr-surface: #ffffff;
  --sr-radius: 10px;
  --sr-shadow: 0 2px 8px rgba(0,0,0,0.07);
}
.sr-page {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background: var(--sr-bg);
  font-family: "Inter Tight", sans-serif;
}
.sr-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 24px;
  background: var(--sr-surface);
  border-bottom: 1px solid var(--sr-border);
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  flex-wrap: wrap;
}
.sr-header__icon {
  width: 42px;
  height: 42px;
  border-radius: 11px;
  background: rgba(227, 253, 100, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.sr-header__icon mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: var(--cf-brand-dark);
}
.sr-header__title {
  margin: 0 0 2px;
  font-size: 1rem;
  font-weight: 700;
  color: var(--sr-text);
  line-height: 1.3;
}
.sr-header__sub {
  margin: 0;
  font-size: 0.78rem;
  color: var(--sr-muted);
}
.sr-body {
  padding: 20px 24px;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
@media (max-width: 768px) {
  .sr-header {
    padding: 10px 14px;
  }
  .sr-body {
    padding: 12px;
  }
}
.sr-search-panel {
  background: var(--sr-surface);
  border: 1px solid var(--sr-border);
  border-radius: var(--sr-radius);
  box-shadow: var(--sr-shadow);
  overflow: hidden;
}
.sr-search-panel__head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: var(--sr-bg);
  border-bottom: 1px solid var(--sr-border);
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--sr-text);
}
.sr-search-panel__head mat-icon {
  font-size: 15px;
  width: 15px;
  height: 15px;
  color: var(--sr-brand);
}
.sr-search-panel__body {
  padding: 16px;
}
.sr-search-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 4px;
  flex-wrap: wrap;
}
.sr-error {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #dc2626;
  flex: 1;
}
.sr-error mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.sr-btn-search {
  background-color: var(--sr-brand) !important;
  color: rgba(0, 0, 0, 0.85) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  min-width: 120px;
}
.sr-btn-search:disabled {
  opacity: 0.6;
}
.sr-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  padding: 48px 0;
}
.sr-loading__dots {
  display: flex;
  gap: 8px;
}
.sr-loading__dots span {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--sr-brand);
  opacity: 0.3;
  animation: sr-pulse 1.2s ease-in-out infinite;
}
.sr-loading__dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.sr-loading__dots span:nth-child(3) {
  animation-delay: 0.4s;
}
.sr-loading__text {
  margin: 0;
  font-size: 14px;
  color: var(--sr-muted);
}
@keyframes sr-pulse {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.9);
  }
  40% {
    opacity: 1;
    transform: scale(1.15);
  }
}
.sr-results {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.sr-results__count {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: #16a34a;
}
.sr-results__count mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.sr-result-card {
  background: var(--sr-surface);
  border: 1px solid var(--sr-border);
  border-radius: var(--sr-radius);
  box-shadow: var(--sr-shadow);
  overflow: hidden;
  transition: box-shadow 0.15s, transform 0.15s;
}
.sr-result-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}
.sr-result-card__header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 18px;
  flex-wrap: wrap;
}
.sr-result-card__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  flex-shrink: 0;
}
.sr-result-card__icon-wrap mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.sr-result-card__icon--invoice {
  background: rgba(37, 99, 235, 0.10);
}
.sr-result-card__icon--invoice mat-icon {
  color: #2563eb;
}
.sr-result-card__icon--preinvoice {
  background: rgba(227, 253, 100, 0.12);
}
.sr-result-card__icon--preinvoice mat-icon {
  color: var(--sr-brand);
}
.sr-result-card__icon--delivery {
  background: rgba(22, 163, 74, 0.10);
}
.sr-result-card__icon--delivery mat-icon {
  color: #16a34a;
}
.sr-result-card__icon--ticket {
  background: rgba(124, 58, 237, 0.10);
}
.sr-result-card__icon--ticket mat-icon {
  color: #7c3aed;
}
.sr-result-card__info {
  min-width: 130px;
}
.sr-result-card__type {
  margin: 0;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--sr-muted);
}
.sr-result-card__number {
  margin: 2px 0 0;
  font-size: 15px;
  font-weight: 700;
  color: var(--sr-text);
}
.sr-result-card__meta {
  display: flex;
  gap: 16px;
  flex: 1;
  flex-wrap: wrap;
  align-items: center;
}
.sr-meta-item {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: #374151;
}
.sr-meta-item mat-icon {
  font-size: 15px;
  width: 15px;
  height: 15px;
  color: var(--sr-muted);
}
.sr-meta-item--amount {
  font-weight: 600;
  color: var(--sr-text);
}
.sr-btn-download {
  background-color: var(--sr-brand) !important;
  color: rgba(0, 0, 0, 0.85) !important;
  font-weight: 500 !important;
  font-size: 13px !important;
  border-radius: 8px !important;
  margin-left: auto;
  flex-shrink: 0;
}
.sr-result-card__lines {
  padding: 10px 18px 14px;
  border-top: 1px solid #f0f0f0;
  background: #fafafa;
}
.sr-lines-label {
  margin: 0 0 8px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--sr-muted);
}
.sr-lines-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.sr-line-item {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  background: rgba(227, 253, 100, 0.08);
  border: 1px solid rgba(227, 253, 100, 0.2);
  font-size: 12px;
  color: #92400e;
  font-weight: 500;
}
::ng-deep .sr-search-panel__body .mat-mdc-form-field-subscript-wrapper {
  min-height: 0 !important;
}
::ng-deep .sr-search-panel__body .mat-mdc-form-field-bottom-align::before {
  display: none !important;
}
@media (max-width: 767px) {
  .sr-result-card__header {
    flex-wrap: wrap;
    gap: 10px;
  }
  .sr-btn-download {
    margin-left: 0;
    width: 100%;
    justify-content: center;
  }
}
/*# sourceMappingURL=salesreport.component.css.map */
